import { defineStore } from 'pinia';
import { computed, ref } from 'vue';
import router from '@/router';
import { useApi } from '@/composables/useApi';

export const useNotificationStore = defineStore('notificationStore', () => {
  const { apiGet, apiPost, apiRequest } = useApi();
  const notifications = ref([]);

  const notificationsCount = computed(() => notifications.value?.length);
  const hasNotifications = computed(() => notificationsCount.value > 0);
  const newNotifications = computed(() => notifications.value.filter((notification) => !notification.seen));
  const hasNewNotifications = computed(() => newNotifications.value.length > 0);

  async function getNotifications() {
    notifications.value = await apiGet('notifications');
  }

  function addNotification(notification) {
    notifications.value.unshift(notification);
  }

  async function updateNotification(id) {
    await apiPost(`notifications/${id}/seen`);

    const index = notifications.value.findIndex((notification) => notification.id === id);
    if (index !== -1) {
      notifications.value[index].seen = true;
    }
  }

  async function updateNotificationsSeen() {
    return apiPost(`notifications/seen`, {
      ids: newNotifications.value.map((notification) => notification.id),
    });
  }

  async function removeNotification(notification) {
    const id = notification.id;

    const index = notifications.value.findIndex((notification) => notification.id === id);
    notifications.value.splice(index, 1);
    await apiRequest({ url: 'notifications/' + id, method: 'DELETE' });
  }

  async function removeNotifications() {
    await apiRequest({ url: 'notifications', method: 'DELETE' });
    setTimeout(() => {
      notifications.value.splice(0, notificationsCount.value);
    }, 300);
  }

  function notificationAction(notificationData) {
    if (!notificationData) {
      return;
    }

    router.push({ name: notificationData.action, params: { ...notificationData } });

    if (notificationData.notificationId) {
      updateNotification(notificationData.notificationId);
    }
  }

  return {
    notifications,
    notificationsCount,
    hasNotifications,
    newNotifications,
    hasNewNotifications,
    getNotifications,
    addNotification,
    updateNotificationsSeen,
    removeNotification,
    removeNotifications,
    notificationAction,
  };
});
